export default "__VITE_ASSET__CSgge_tE__"